<template>
    <DModal
        :title="__('customers.contracts.create_contract_tree.product_packages')"
        :show="showModal || modalHasErrors"
        is-medium
        close-color-secondary
        @close="$emit('close-modal')"
    >
        <DCard
            padding
        >
            <DFormRow
                :label="__('customers.contracts.create_contract_tree.choose_product_package')"
                :error="errors.product_package_id"
                is-required
                class="mb-0"
            >
                <DSelect
                    id="product_package"
                    v-model="productPackageId"
                    :options="productPackages"
                    :placeholder="__('customers.contracts.create_contract_tree.choose_product_package')"
                    @change="packageContainRetiredProduct()"
                />
                <ul class="p-0">
                    <li
                        v-for="(error, index) in errors.errorsData"
                        :key="index"
                        class="error-msg"
                    >
                        {{ error }}
                    </li>
                </ul>
            </DFormRow>
            <DAlert
                v-if="showWarningPackageContainRetiredProducts"
                color="warning"
            >
                {{ __('customers.contracts.create_contract_tree.package_contains_retired_product') }}
            </DAlert>
        </DCard>
        <template #actions>
            <DButton
                :disabled="isInLoadingState"
                :loading="isInLoadingState"
                :label="__('messages.confirm')"
                color="primary"
                @click="confirm"
            />
        </template>
    </DModal>
</template>

<script>

export default {
    name: 'ProductPackageModal',
    props: {
        customer: {
            type: Object,
            default: () => { return {} }
        },
        productPackages: {
            type: Array,
            default: () => { return [] }
        },
        showModal: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close-modal', 'load-package'],
    data () {
        return {
            productPackageId: null,
            showWarningPackageContainRetiredProducts: false,
            errors: {},
            modalHasErrors: false
        }
    },
    methods: {
        packageContainRetiredProduct () {
            window.axios.get(this.$route('products.product-packages.package-contain-retired-product', {
                productPackage: this.productPackageId
            }))
                .then((res) => {
                    this.showWarningPackageContainRetiredProducts = res.data.containRetiredProduct
                })
        },
        confirm () {
            window.axios.get(this.$route('customers.customers.contracts.load-product-package', {
                customer: this.customer.id,
                productPackage: this.productPackageId
            }))
                .then((response) => {
                    this.$emit('load-package', response.data)
                    this.errors = {}
                    this.modalHasErrors = false
                })
                .catch((error) => {
                    if (error && error.response && error.response.data.errors !== undefined) {
                        this.errors = error.response.data.errors

                        for (const key in this.errors) {
                            if (typeof this.errors[key] === 'object') {
                                this.errors[key] = this.errors[key][0]
                            }
                        }

                        this.modalHasErrors = true
                    }

                    this.modalHasErrors = true
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.error-msg {
    margin: 3px 20px 0 0;
    text-align: center;
    font-size: 12px;
    color: var(--colorDanger);
}
</style>
